import { Box, Fade } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

interface IconToggleProps {
  defaultIcon: React.ReactElement;
  toggledIcon: React.ReactElement;
  isToggled: boolean;
  onToggle: (isToggled: boolean) => void;
}

const TRANSITION_DELAY = 800;
const TOGGLE_DELAY = 2000;

export const IconToggle = ({
  defaultIcon,
  toggledIcon,
  isToggled,
  onToggle,
}: IconToggleProps) => {
  const [shouldShowDefaultIcon, setShouldShowDefaultIcon] = useState(true);
  const intervalRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!isToggled) {
      return;
    }

    setShouldShowDefaultIcon(false);

    const toggleIcons = () => {
      setShouldShowDefaultIcon(true);
      onToggle(false);
      if (intervalRef.current) {
        clearTimeout(intervalRef.current);
      }
    };

    intervalRef.current = setTimeout(toggleIcons, TOGGLE_DELAY);

    return () => {
      if (intervalRef.current) {
        clearTimeout(intervalRef.current);
      }
    };
  }, [shouldShowDefaultIcon, onToggle, isToggled]);

  if (shouldShowDefaultIcon) {
    return (
      <Fade in={shouldShowDefaultIcon} timeout={TRANSITION_DELAY} key="default">
        <Box>{defaultIcon}</Box>
      </Fade>
    );
  }

  if (!shouldShowDefaultIcon) {
    return (
      <Fade
        in={!shouldShowDefaultIcon}
        timeout={TRANSITION_DELAY}
        key="toggled"
      >
        <Box>{toggledIcon}</Box>
      </Fade>
    );
  }

  return null;
};
